import { Button, Icon } from '@octano/global-ui';
import { useCallback } from 'react';
import { Card, Col, Row } from 'reactstrap';

export interface FileDownloadProps {
  file?: {
    name: string;
    url: string;
  };
  text: string;
  label: string;
}

export default function FileDownload({ file, text, label }: FileDownloadProps) {
  const downloadFile = useCallback(
    (fileItem: { name: string; url: string }) => {
      const link = document.createElement('a');
      link.download = fileItem.name;
      link.href = fileItem.url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    [],
  );

  return (
    <Card>
      {!!file && (
        <Row className="d-flex flex-row align-items-center">
          <Col xs={12} sm={12}>
            <label className="g-file-input-label text-left">{label}</label>
          </Col>
          <Col xs={12} sm={6}>
            <div className="g-file-input-container d-flex align-items-center">
              <>
                <span>
                  <Icon name="file_img" size="25px" color="primary" />
                </span>
                <span className="g-file-input-name">{file.name}</span>
              </>
            </div>
          </Col>
          <Col xs={12} sm={6}>
            <Button
              text={text}
              color="primary"
              outlined
              size="md"
              disabled={!file}
              onClick={downloadFile.bind(null, file)}
              icon="download"
              fullwidth
            />
          </Col>
        </Row>
      )}
    </Card>
  );
}
